import { Translation } from '@ps/web-shared-components';
import { get } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CasinoGameList } from '@swf/casino';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { Dispatch } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';

import { TXTACL_Pick_Your_Game } from './CasinoGameSelector.messages.json';
import styles from './CasinoGameSelector.scss';

interface CasinoGameSelectorParams {
  widgetId: string;
  path: string;
}

const CasinoGameSelector: React.FC = () => {
  const { widgetId, path } = useSearchParams<CasinoGameSelectorParams>();
  const { modal } = useDispatch<Dispatch>();
  const { widgetSelect } = useWidget(widgetId);
  const data = useSelector(widgetSelect?.get);

  const race: CasinoRace = get(data, path);
  return (
    <div className={styles.container}>
      <Header className={styles.header}>
        <Translation {...TXTACL_Pick_Your_Game} />
        <CloseButton variant={Variant.Light} />
      </Header>
      <CasinoGameList
        games={race.multiGameList || []}
        className={styles.gameList}
        icon="icnSquare"
        race={{ ...race, multiGameList: [] }}
        dynamicColumnFit
        onLaunch={() => modal.close()}
      />
    </div>
  );
};

export default CasinoGameSelector;
